import React, { useState, useEffect } from 'react'
import {apiGetReport, apiGetReportList} from 'api-methods'
import Notification from "../components/Notification"
import CustomSelect from "../components/CustomSelect" // ← импортируем
import '../css/FilterPanelReports.css'
import { useLocation, useNavigate } from "react-router-dom"
import { handleAuthErrorAndRedirect, isSuccessStatus } from '../utils/authError'

const FilterPanelSubs = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [selectedReport, setSelectedReport] = useState('24')
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1)
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear())
    const [availableMonths, setAvailableMonths] = useState([])
    const [availableYears, setAvailableYears] = useState([])
    const [notification, setNotification] = useState(null)
    const [reportsType, setReportsType] = useState({})
    const [isDownloadingReport, setIsDownloadingReport] = useState(false)
    const showNotification = (message, type = 'success') => {setNotification({ message, type })}
    const hideNotification = () => {setNotification(null)}

    // Генерация списка месяцев с учетом текущей даты
    const generateMonths = (year) => {
        const currentDate = new Date()
        const currentYear = currentDate.getFullYear()
        const currentMonth = currentDate.getMonth() + 1

        const allMonths = [
            { value: 1, label: 'Январь' },
            { value: 2, label: 'Февраль' },
            { value: 3, label: 'Март' },
            { value: 4, label: 'Апрель' },
            { value: 5, label: 'Май' },
            { value: 6, label: 'Июнь' },
            { value: 7, label: 'Июль' },
            { value: 8, label: 'Август' },
            { value: 9, label: 'Сентябрь' },
            { value: 10, label: 'Октябрь' },
            { value: 11, label: 'Ноябрь' },
            { value: 12, label: 'Декабрь' }
        ]

        if (year === currentYear) {
            return allMonths.filter(month => month.value <= currentMonth)
        }
        return allMonths
    }

    // Генерация списка годов (текущий и 5 прошлых)
    const generateYears = () => {
        const currentYear = new Date().getFullYear()
        return Array.from({ length: 6 }, (_, i) => currentYear - i)
    }

    // при изменении года → Обновление доступных месяцев ( не всех а доступных )
    useEffect(() => {
        const years = generateYears()
        setAvailableYears(years)

        const months = generateMonths(selectedYear)
        setAvailableMonths(months)

        // Если выбранный месяц недоступен в новом году, выбираем последний доступный
        const isMonthAvailable = months.some(month => month.value === selectedMonth)
        if (!isMonthAvailable && months.length > 0) {
            setSelectedMonth(months[months.length - 1].value)
        }
    }, [selectedYear])

    // при первом рендере
    useEffect(() => {
        const years = generateYears()
        setAvailableYears(years)

        const months = generateMonths(selectedYear)
        setAvailableMonths(months)
    }, [])

    useEffect(() => {
        apiGetReportList()
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
                if (isSuccessStatus(data.code)) {
                    if (typeof data.data === 'string') {data.data = JSON.parse(data.data)}
                    setReportsType(data.data)
                }
            })
            .catch(_ => {})
    }, [])

    function formatMonth(month) {return month.toString().padStart(2, '0')}
    function getReportName (selectedReport) {return Date.now() + '.csv'}

    // Преобразуем reportsType в массив для CustomSelect
    const getReportOptions = () => {
        return Object.keys(reportsType)
            .filter(key => reportsType[key].enabled)
            .map(key => ({
                value: reportsType[key].reportId,
                label: reportsType[key].reportName
            }))
    }

    // загрузка отчета
    const downloadReport = () => {
        if (isDownloadingReport) return
        setIsDownloadingReport(true)
        let dataForApiReq = {reportId: selectedReport, reportDate: selectedYear + "-" + (('' + selectedMonth).length === 1 ? ("0" + selectedMonth) : selectedMonth)}
        apiGetReport(dataForApiReq)
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
                if (isSuccessStatus(data.code) && data.data && !data.data.message) {
                    try {
                        if (!data.data) {
                            console.error('No data !!')
                            return
                        }

                        let csvData = data.data
                        if (Array.isArray(csvData) && csvData.length > 0) {
                            const headers = Object.keys(csvData[0]) // заголовки
                            const csvRows = [] // Создаем CSV
                            csvRows.push(headers.join(';')) // заголовки
                            // данные
                            csvData.forEach(row => {
                                const values = headers.map(header => {
                                    // кавычки и запятые
                                    let value = row[header] !== null && row[header] !== undefined ? String(row[header]) : ''
                                    if (value.includes(';') || value.includes('"') || value.includes('\n')) {
                                        value = `"${value.replace(/"/g, '""')}"`
                                    }
                                    return value
                                })
                                csvRows.push(values.join(';'))
                            })

                            csvData = csvRows.join('\n')
                        } else if (typeof csvData === 'object') {
                            csvData = String(csvData)
                        }

                        // Добавляем BOM для Excel
                        const BOM = '\uFEFF'
                        const blob = new Blob([BOM + csvData], {type: 'text/csv;charset=utf-8;'})

                        // Создаем URL для blob
                        const url = URL.createObjectURL(blob)
                        const link = document.createElement('a')
                        link.href = url
                        link.style.display = 'none'

                        // Формируем имя файла
                        const reportName = getReportName(selectedReport)
                        const fileName = `${reportName}_${selectedYear}-${selectedMonth.toString().padStart(2, '0')}.csv`
                        link.setAttribute('download', fileName)
                        link.setAttribute('target', '_blank')

                        document.body.appendChild(link) // Добавляем ссылку в DOM и кликаем

                        setTimeout(() => {
                            link.click()
                            setTimeout(() => {
                                document.body.removeChild(link)
                                URL.revokeObjectURL(url)
                            }, 100)
                        }, 100)
                    } catch (error) {
                        console.error('Error downloading CSV:', error)
                    }
                } else {
                    showNotification('Нет данных для отчёта', 'error')
                }
            })
            .catch(_ => {})
            .finally(_ => {setIsDownloadingReport(false)})
    }

    return (
        <div className="componentFilterReport">
            <div className="report-toolbar-shell">
                <div className="report-toolbar">
                    <div className="report-toolbar__controls">
                        <div className="report-toolbar__group report-toolbar__group--type">
                            <div className="report-toolbar__label">Тип&nbsp;отчёта</div>
                            <div className="report-toolbar__field">
                                <CustomSelect
                                    value={selectedReport}
                                    options={getReportOptions()}
                                    onChange={(value) => setSelectedReport(value)}
                                    className="report-type-select"
                                    optionLabelKey="label"
                                    optionValueKey="value"
                                />
                            </div>
                        </div>
                        <div className="report-toolbar__group report-toolbar__group--date">
                            <div className="report-toolbar__label">Дата</div>
                            <div className="report-toolbar__date-fields">
                                <div className="report-toolbar__field">
                                    <CustomSelect
                                        value={selectedMonth}
                                        options={availableMonths.map(m => ({ value: m.value, label: m.label }))}
                                        onChange={(value) => setSelectedMonth(parseInt(value))}
                                        className="month-select"
                                        optionLabelKey="label"
                                        optionValueKey="value"
                                    />
                                </div>
                                <div className="report-toolbar__field">
                                    <CustomSelect
                                        value={selectedYear}
                                        options={availableYears.map(y => ({ value: y, label: y.toString() }))}
                                        onChange={(value) => setSelectedYear(parseInt(value))}
                                        className="year-select"
                                        optionLabelKey="label"
                                        optionValueKey="value"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-toolbar__footer">
                        <div className="report-toolbar__hint">Для формирования отчета выберете его тип, дату и нажмите "Скачать отчет"</div>
                        <div className="allPagesStyleButton-pos">
                            <button type="button" className="report-download-button" onClick={downloadReport} disabled={isDownloadingReport}>
                                <span>Скачать отчёт</span>
                                {isDownloadingReport && <span className="report-download-button__loader" aria-hidden="true" />}
                            </button>
                        </div>
                    </div>
                </div>
                {notification && (
                    <Notification
                        message={notification.message}
                        type={notification.type}
                        onClose={hideNotification}
                        duration={3000}
                    />
                )}
            </div>
        </div>
    )
}

export default FilterPanelSubs

